<template>
  <div class="container">
    <van-nav-bar title="缴费凭证" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="menu">
      <van-field readonly label="所属项目：" :value="communityName" />
      <van-field readonly label="缴费日期：" :value="time" />
    </div>
    <div class="mg12">
      <van-field center readonly label="物联网确认：" placeholder="" />
    </div>
    
    <div class="listbox">
      <van-row>
        <van-col span="12">设备编号</van-col>
        <van-col span="12">网卡/宽带编号</van-col>
      </van-row>
      <van-row :key="index" v-for="(item,index) in cardList">
        <van-col span="12">{{item.mainNo}}</van-col>
        <van-col span="12">{{item.cardNo}}</van-col>
      </van-row>
    </div>

    <div class="mg12">
      <van-field center readonly label="缴费凭证：" placeholder="" />

      <div class="upImgBox">
        <van-uploader
          v-model="imgList"
          :max-size="10485760"
          :before-read="beforeRead"
          :before-delete="delImg"
        />
      </div>
    </div>

    <div class="botBox clearfix">
      <div class="fl_left">
        <span class="lab">单据数量</span>
        <span class="val col_b">{{upImgList.length}}</span>
      </div>
      <div class="fl_right">
        <van-button round type="info" @click="upCheckList" :disabled="upImgList.length == 0 || idList.length == 0">提交凭证</van-button>
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {uploadFiles} from '@/upload.js';
  import ImageCompressor from 'image-compressor.js' //js图片压缩旋转库
  import {NavBar,Icon,Image,Toast,Button,Field,Col,Row,Uploader} from 'vant';
  export default {
    data() {
      return {
        communityId: '',
        communityName: '',
        expireDate:'',
        time:'',
        idList:[],
        cardList:[],
        imgList:[],
        upImgList:[],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Col.name]:Col,
      [Row.name]:Row,
      [Uploader.name]:Uploader,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html",query:{active:0,communityName:this.communityName,fileNum:this.upImgList.length}});
      },
      beforeRead(file) {
        var that = this;
        if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png' && file.type !== 'image/bmp') {
          Toast('请上传 jpg jpeg png bmp 格式图片');
          return false;
        } else if (file.size > 10485760 ) {
          Toast('请上传不大于 10M 的图片');
          return false;
        } else{
          new ImageCompressor(file, {
            quality: 0.6, //压缩质量
            checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
            success(result) {
              //压缩后的文件会自动转换成二进制文件流类型
              //这里可以发ajax，上传图片
              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '图片上传中...'
              });
              that.uprightSuc(result.name,result);
            }
          })
          return true;
        }
        
      },
      delImg(item,index){
        console.log(index)
        this.upImgList.splice(index, 1);
        console.log(this.upImgList)
        return true;
      },
      uprightSuc(imgName, imgFile) {
          let _this = this;
          uploadFiles(imgName, imgFile)         
          .then(function (result) {
            _this.upImgList.push(result.name);
            Toast.clear();
          })
          .catch(function (err) {
            console.log('err', err)
          })
      },
      getMeterInfo() {
        axios.get("/center/deviceremaindcardlist?communityId="+this.communityId+'&expireDate='+this.expireDate).then((res)=>{
          if(res.data){
            this.cardList = res.data.cardList;
            this.communityId = res.data.communityId;
            this.communityName = res.data.communityName;
            this.time = res.data.expireDate;
            var arr = []
            res.data.cardList.forEach(element => {
              arr.push(element.id)
            });
            this.idList = arr;
          }
        })
      },
      upCheckList() {
        //上传
        // Toast.loading({
        //   duration: 0,       // 持续展示 toast
        //   forbidClick: true, // 禁用背景点击
        //   loadingType: 'spinner',
        //   message: '提交中...'
        // });
        if(this.upImgList.length == 0){
          Toast('请上传缴费凭证');
          return
        }
        axios.post("/center/paymentdeviceinternetcard",{
          idList: this.idList,
          paymentCertificateList: this.upImgList,
        }).then((res)=>{
          if(res.isSuccess){
            Toast('提交成功');
            setTimeout(()=>{
              this.$router.replace({path: "home.html"});
            },1500)
          }
        })
      },
      onClickLeft() {
        this.$router.replace({path: "home.html"});
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.communityId = this.$route.query.communityId;
      this.expireDate = this.$route.query.expireDate;
      this.getMeterInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 100px;
  }
  
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    .van-row{
      border-bottom: 1px solid #F0F4F7;
    }
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .botBox{
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 12px;
    box-sizing: border-box;
    box-shadow: 0px 0px 6px 1px rgba(190,228,255,0.71);
    .lab{
      margin-right: 10px;
    }
    .van-button{width: 170px;line-height: 60px;}
  }
  .mg12{margin-top: 12px;}
  .upImgBox{
    background: #fff;
    padding: 12px 18px;
    .van-uploader__upload{width: 60px !important;height: 60px !important;}
  }
</style>
